export enum LineItemType {
  APPLIED_LOYALTY_PROMOTION = 'APPLIED_LOYALTY_PROMOTION',
  DONATION = 'DONATION',
  ESTIMATED_SHIPPING = 'ESTIMATED_SHIPPING',
  ESTIMATED_TAX = 'ESTIMATED_TAX',
  ESTIMATED_TOTAL = 'ESTIMATED_TOTAL',
  GIFT_CARD_TOTAL = 'GIFT_CARD_TOTAL',
  ORDER_PROMOTION = 'ORDER_PROMOTION',
  ORDER_SUBTOTAL = 'ORDER_SUBTOTAL',
  POINT_PROMOTION = 'POINT_PROMOTION',
  SCORECARD_REWARD = 'SCORECARD_REWARD',
  SCORECARD_HUB_REWARD = 'SCORECARD_HUB_REWARD',
  SHIPPING_PROMOTION = 'SHIPPING_PROMOTION',
  SPACER = 'SPACER',
  ORDER_SUMMARY = 'ORDER_SUMMARY',
  STORE_PICKUP = 'STORE_PICKUP',
}
